import * as React from 'react';
import * as styles from './styles.css';
import { YouTube } from './YouTube';

export interface IVideoPlayerProps {
  videoId: string;
  preview: React.ReactElement;
  isCurrent?: boolean;
}

export const VideoPlayer = ({ videoId, preview, isCurrent }: IVideoPlayerProps) => {
  const [isActive, setIsActive] = React.useState(false);

  React.useEffect(() => {
    if (!isCurrent) {
      setIsActive(false);
    }
  }, [isCurrent]);

  const handlePreviewClick = (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    event.preventDefault();
    setIsActive(true);
  };

  return (
    <div className={styles['container']}>
      {isActive ? (
        <YouTube videoId={videoId} />
      ) : (
        <div className={styles['preview']} onClick={handlePreviewClick}>
          {preview}
        </div>
      )}
    </div>
  );
};
